import Model, { attr, belongsTo } from '@ember-data/model'

export default class DatasetModel extends Model 
{
	@attr name;
	@attr path;
	@attr('number') port;
	@attr destinationFileName;
	@attr('number') period;
	@attr('boolean') enabled;
	@belongsTo('source',{inverse: 'datasets', async: true}) SourceId;
}